import React from 'react';
import '../../styles/Homepage.css';
import '../../styles/Fonts.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

const WhyChooseUs = () => {
  return (
    <section className="services-preview-section">
      <div className="container">
        <div className="about-content-wrapper">
          <div className="about-image-content">
            <div className="about-stats">
              <div className="stat-item">
                <div className="stat-icon">
                  <i className="fas fa-calendar-alt"></i>
                </div>
                <span className="stat-number">30+</span>
                <div className="stat-label">Years Experience in Logistics</div>
              </div>
              <div className="stat-item">
                <div className="stat-icon">
                  <i className="fas fa-globe"></i>
                </div>
                <span className="stat-number">Global</span>
                <div className="stat-label">Network Worldwide Partners</div>
              </div>
              <div className="stat-item">
                <div className="stat-icon">
                  <i className="fas fa-users"></i>
                </div>
                <span className="stat-number">Expert</span>
                <div className="stat-label">Dedicated Team Professionals</div>
              </div>
              <div className="stat-item">
                <div className="stat-icon">
                  <i className="fas fa-handshake"></i>
                </div>
                <span className="stat-number">Trusted</span>
                <div className="stat-label">Partner Reliable Services</div>
              </div>
            </div>
          </div>
          <div className="about-text-content">
            <div className="section-badge">WHO WE ARE</div>
            <h2 className="section-title">Why Choose Us</h2>
            <p className="section-description">
              RCS Logistics Phils., Inc. has been a cornerstone in the logistics industry since its establishment in 1991, 
              proudly standing as a fully Filipino-owned and operated company. Specializing in international freight forwarding 
              and customs brokerage, the company has earned a distinguished reputation, particularly in the Asia-US trade lanes, 
              where it delivers seamless and efficient logistics solutions.
            </p>
            <p className="section-description">
              With over three decades of experience, RCS Logistics has successfully managed thousands of shipments, 
              demonstrating its capability to meet the complex demands of modern logistics. At the heart of its operations 
              is a dedicated team of highly qualified employees, whose expertise and professionalism ensure that every 
              client's needs are met with precision.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;